import { render } from "./PremiumPhoneToggle.vue?vue&type=template&id=6b610f2a&scoped=true"
import script from "./PremiumPhoneToggle.vue?vue&type=script&lang=js"
export * from "./PremiumPhoneToggle.vue?vue&type=script&lang=js"

import "./PremiumPhoneToggle.vue?vue&type=style&index=0&id=6b610f2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b610f2a"]])

export default __exports__